export default __webpack_public_path__ + "static/media/D.ab8eef6e.svg";